import { useGet } from './useHttpHooks';
import { ArticleListItemModel } from '../types';
import toQuery from '../lib/toQuery';

type GetArticlesByTagsQuery = {
    tags: string[];
};

const useGetArticlesByTags = (request: GetArticlesByTagsQuery) =>
    useGet<ArticleListItemModel[]>(
        `/api/articles/by-tags?${toQuery(request)}`,
        {
            errorMessage: 'GET /api/articles/by-tags failed'
        }
    );

export default useGetArticlesByTags;
